module.exports = __webpack_public_path__ + "static/media/gy.915d7874.webp";